import { Leave, LeaveRecsQuery } from './leaves.model';

export interface LeaveState {
  leaveRecords: Leave[];
  listLoading: boolean;
  totalCount: number;
  lastQuery: LeaveRecsQuery;
  selectedLeave: Leave | null;
  leaveTypes: { label: string; value: string }[];
  actionLoading: boolean;
}

export const LeaveActionTypes = {
  LeavePageRequested: '[LEAVE] PageRequested [API]',
  LeavePageToggleLoading: '[LEAVE] Page Toggle Loading [ACTION]',
  LeavePageLoaded: '[LEAVE] Page Loaded [ACTION]',

  // New action types
  LeaveDetailRequested: '[LEAVE] Detail Requested [API]',
  LeaveDetailLoaded: '[LEAVE] Detail Loaded [ACTION]',

  LeaveApplyRequested: '[LEAVE] Apply Requested [API]',
  LeaveApplySuccess: '[LEAVE] Apply Success [ACTION]',

  LeaveUpdateRequested: '[LEAVE] Update Requested [API]',
  LeaveUpdateSuccess: '[LEAVE] Update Success [ACTION]',

  LeaveDeleteRequested: '[LEAVE] Delete Requested [API]',
  LeaveDeleteSuccess: '[LEAVE] Delete Success [ACTION]',

  LeaveTypesRequested: '[LEAVE] Types Requested [API]',
  LeaveTypesLoaded: '[LEAVE] Types Loaded [ACTION]',

  LeaveActionToggleLoading: '[LEAVE] Action Toggle Loading [ACTION]',
};

interface LeavePageRequested {
  type: typeof LeaveActionTypes.LeavePageRequested;
  payload: { query: LeaveRecsQuery };
}

interface LeavePageToggleLoading {
  type: typeof LeaveActionTypes.LeavePageToggleLoading;
  payload: { isLoading: boolean };
}

interface LeavePageLoaded {
  type: typeof LeaveActionTypes.LeavePageLoaded;
  payload: { leaveRecords: Leave[]; query: LeaveRecsQuery; totalCount: number };
}

// New action interfaces
interface LeaveDetailRequested {
  type: typeof LeaveActionTypes.LeaveDetailRequested;
  payload: { leaveId: string; callback?: () => void };
}

interface LeaveDetailLoaded {
  type: typeof LeaveActionTypes.LeaveDetailLoaded;
  payload: { leaveDetail: Leave };
}

interface LeaveApplyRequested {
  type: typeof LeaveActionTypes.LeaveApplyRequested;
  payload: { leaveData: Leave; callback?: (responseLeave: Leave) => void };
}

interface LeaveApplySuccess {
  type: typeof LeaveActionTypes.LeaveApplySuccess;
}

interface LeaveUpdateRequested {
  type: typeof LeaveActionTypes.LeaveUpdateRequested;
  payload: { leaveData: Leave; callback?: () => void };
}

interface LeaveUpdateSuccess {
  type: typeof LeaveActionTypes.LeaveUpdateSuccess;
}

interface LeaveDeleteRequested {
  type: typeof LeaveActionTypes.LeaveDeleteRequested;
  payload: { leaveId: string; rosterDayId: string; callback?: () => void };
}

interface LeaveDeleteSuccess {
  type: typeof LeaveActionTypes.LeaveDeleteSuccess;
}

interface LeaveTypesRequested {
  type: typeof LeaveActionTypes.LeaveTypesRequested;
}

interface LeaveTypesLoaded {
  type: typeof LeaveActionTypes.LeaveTypesLoaded;
  payload: { leaveTypes: { label: string; value: string }[] };
}

interface LeaveActionToggleLoading {
  type: typeof LeaveActionTypes.LeaveActionToggleLoading;
  payload: { isLoading: boolean };
}

export type ActionTypes =
  | LeavePageRequested
  | LeavePageToggleLoading
  | LeavePageLoaded
  | LeaveDetailRequested
  | LeaveDetailLoaded
  | LeaveApplyRequested
  | LeaveApplySuccess
  | LeaveUpdateRequested
  | LeaveUpdateSuccess
  | LeaveDeleteRequested
  | LeaveDeleteSuccess
  | LeaveTypesRequested
  | LeaveTypesLoaded
  | LeaveActionToggleLoading;
